var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.951,7.903c-0.414,0-0.75,0.336-0.75,0.75v1.562c0,0.576-0.468,1.044-1.044,1.044H8.534c-0.414,0-0.75,0.336-0.75,0.75 c0,2.265,1.869,4.107,4.167,4.107s4.168-1.843,4.168-4.107C16.119,9.745,14.249,7.903,11.951,7.903z M11.951,14.616 c-1.204,0-2.224-0.784-2.555-1.857h0.761c1.403,0,2.544-1.141,2.544-2.544V9.508c1.107,0.317,1.918,1.318,1.918,2.501 C14.619,13.446,13.422,14.616,11.951,14.616z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.965,11.763c-0.023-0.072-2.378-7.206-10.056-7.258c-7.547,0-9.853,7.191-9.875,7.264 c-0.045,0.146-0.044,0.302,0.002,0.448c0.023,0.072,2.377,7.227,9.976,7.277c0.002,0,0.08,0,0.082,0 c7.547,0,9.852-7.21,9.874-7.283C22.012,12.065,22.011,11.909,21.965,11.763z M12.093,17.994v0.75l-0.072-0.75 c-5.859-0.039-8.046-4.879-8.476-6.007c0.421-1.131,2.571-5.981,8.434-5.981c5.854,0.04,8.042,4.855,8.475,5.985 C20.031,13.102,17.841,17.994,12.093,17.994z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.380614858580ac0a285d1eb20f82d4fd.svg";
export { ForwardRef as ReactComponent };